//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import { TableStatus } from '@/components/_common/Table';
import Notes from '../_common/Notes/Notes';
import AssigneeSelect from '../_common/AssigneeSelect/AssigneeSelect';
import History from '../_common/History/History';
import TaskType from '../_common/Tasks/TaskType';
import { OrderJobTask } from '@/redux/slices/slice_types';

export default {
  hid: {
    label: 'Task ID',
    sortField: 'id',
    render: (cell: string) => <strong>{cell}</strong>
  },
  step: {
    label: 'Task Type',
    sortField: 'step',
    render: (taskType: string, row: OrderJobTask) => <TaskType type={taskType} prettyName={row?.pretty_name} />
  },
  status: {
    label: 'Status',
    render: (status: string, row: OrderJobTask) => {
      // only display the status reason if status is failed or in_error
      const statusReason = row.status && (row.status === 'failed' || row.status === 'in_error') ? row.status_reason : undefined;
      return <TableStatus status={status} statusReason={statusReason} />;
    }
  },
  assigned_user: {
    label: 'Assignee',
    render: (cell: any, row: OrderJobTask) => (
      <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
        <AssigneeSelect value={cell} id={row.id} assigns="user" viewOnly />
      </div>
    ),
    disableSort: true
  },
  notes: {
    label: 'Notes',
    width: 100,
    render: (cell: unknown, row: OrderJobTask) => (
      <div style={{ width: 32, textAlign: 'center' }}>
        <Notes data={row} />
      </div>
    ),
    disableSort: true
  },
  history: {
    label: 'History',
    width: 100,
    render: (cell: unknown, row: OrderJobTask) => (
      <div style={{ width: 45, textAlign: 'center' }}>
        <History data={row} iconOnly />
      </div>
    ),
    disableSort: true
  }
};
